var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import styles from './LoadingTableItem.module.scss';
import { ZERO_WIDTH_SPACE } from 'src/shared/constants';
export var LoadingTableItem = function (props) {
    var nbOfValues = props.nbOfValues;
    var arrayFromNbOfValesLength = Array.from(Array(nbOfValues).keys());
    return (_jsx("tr", { children: arrayFromNbOfValesLength.map(function (_, index) { return (_jsx("td", __assign({ className: styles.loadingTableItemCell }, { children: _jsx("span", __assign({ className: styles.loadingTableItemCellContent }, { children: ZERO_WIDTH_SPACE })) }), index)); }) }));
};
